import React from 'react'

import { IContestEntry } from 'protos'

import T from 'components/FormattedMessage'

import Label from './Label'

interface Props {
  score: IContestEntry['score']
}

const ScoreLabel: React.SFC<Props> = ({ score }) => (
  <Label
    label={<T id="contest_goal_bestmatchscore_header" />}
    value={<>{score}<T id="common_unit_point" /></>}
  />
)

export default ScoreLabel
